(() => {
  if (customElements.get('oka-halloween-pdp')) return;
  customElements.define('oka-halloween-pdp', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const q = s => this.querySelector(s), qa = s => [...this.querySelectorAll(s)];
      const on = (el, event, fn) => el.addEventListener(event, fn, { signal: this.controller.signal });
      const data = JSON.parse(q('[data-oka-data]').textContent);
      const form = q('.oka-form'), select = q('[data-variant-select]'), qty = q('[name="quantity"]');
      const error = q('[data-error]'), add = q('[data-add]'), price = q('[data-price]');
      const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(n / 100);
      let color = q('.swatches input:checked')?.value || data.variants[0]?.color;
      let size = '', variant = null, busy = false;
      const explicit = data.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant'));
      if (explicit) { color = explicit.color; if (explicit.available) size = explicit.size; }
      const notify = message => { error.textContent = message; error.hidden = !message; };
      const showPhoto = (src, alt, index) => {
        const hero = q('.oka-hero'); hero.src = src; hero.removeAttribute('srcset'); hero.alt = alt || 'Oka Recovery Flip Flop';
        qa('[data-photo]').forEach((b, i) => { b.classList.toggle('selected', i === index); b.setAttribute('aria-pressed', String(i === index)); });
        q('[data-image-count]').textContent = String(index + 1).padStart(2, '0') + ' / ' + String(qa('[data-photo]').length).padStart(2, '0');
      };
      const gallery = () => {
        const colorVariant = data.variants.find(v => v.color === color);
        let photos = data.images.filter(i => i.alt && i.alt.includes(color));
        if (!photos.length) photos = data.images.filter(i => i.src === colorVariant?.image);
        if (!photos.length) photos = data.images.slice(0, 1);
        const heroIndex = photos.findIndex(i => i.src === colorVariant?.image);
        if (heroIndex > 0) photos.unshift(...photos.splice(heroIndex, 1));
        photos = photos.slice(0, 6);
        const tray = q('[data-thumbnails]'); tray.replaceChildren();
        photos.forEach((p, i) => {
          const b = document.createElement('button'); b.type = 'button'; b.dataset.photo = p.src; b.dataset.alt = p.alt;
          b.setAttribute('aria-label', `View ${color} photo ${i + 1}`); const img = document.createElement('img'); img.src = p.thumb; img.alt = ''; img.loading = 'lazy'; b.append(img); tray.append(b);
        });
        if (photos[0]) showPhoto(photos[0].src, photos[0].alt, 0);
      };
      const render = () => {
        variant = data.variants.find(v => v.color === color && v.size === size);
        qa('.swatches input').forEach(i => { i.checked = i.value === color; });
        qa('.sizes input').forEach(i => {
          const v = data.variants.find(v => v.color === color && v.size === i.value);
          i.disabled = !v?.available; i.checked = i.value === size;
          i.parentElement.classList.toggle('unavailable', i.disabled); i.parentElement.classList.toggle('active', i.checked);
          i.setAttribute('aria-label', i.value + (i.disabled ? ' sold out' : ''));
        });
        q('[data-color-label]').textContent = color;
        q('[data-size-label]').textContent = size || 'Select your size';
        const representative = variant || data.variants.find(v => v.color === color);
        price.textContent = representative.priceFormatted;
        q('[data-button-price]').textContent = money(representative.price * Math.max(1, Number(qty.value) || 1)) + ' →';
        q('[data-backorder]').hidden = !variant?.backorder;
        q('[data-sticky-label]').textContent = color + (size ? ' · ' + size : ' · Select your size');
        const colorAvailable = data.variants.some(v => v.color === color && v.available);
        add.disabled = busy || !colorAvailable;
        q('[data-add-label]').textContent = busy ? 'Adding…' : colorAvailable ? 'Add to bag' : 'Sold out';
        select.value = variant ? String(variant.id) : '';
      };
      q('.oka-enhanced').hidden = false; q('[data-native-picker]').hidden = true;
      // Move the existing controls, preserving one heading and one color picker.
      const mobile = matchMedia('(max-width: 700px)');
      const heading = q('[data-product-heading]'), colors = q('[data-color-picker]');
      const headingHome = document.createComment('Product heading');
      const colorsHome = document.createComment('Color picker');
      heading.before(headingHome); colors.before(colorsHome);
      const arrangeProduct = () => {
        if (mobile.matches) {
          q('[data-mobile-heading]').append(heading);
          q('[data-mobile-colors]').append(colors);
        } else {
          headingHome.after(heading); colorsHome.after(colors);
        }
      };
      on(mobile, 'change', arrangeProduct);
      arrangeProduct();
      on(this, 'change', e => {
        if (!e.target.matches('.swatches input, .sizes input') && e.target !== qty) return;
        if (e.target.matches('.swatches input')) {color = e.target.value; if (!data.variants.find(v => v.color === color && v.size === size)?.available) size = '';gallery();}
        if (e.target.matches('.sizes input')) size = e.target.value;
        if (e.target === qty && (!Number.isInteger(Number(qty.value)) || Number(qty.value) < 1)) qty.value = '1';
        notify(''); render();
        const url = new URL(location.href);if (variant) url.searchParams.set('variant', variant.id);else url.searchParams.delete('variant');history.replaceState({}, '', url);
      });
      on(qty, 'input', render);
      on(q('[data-minus]'), 'click', () => { qty.value = String(Math.max(1, (Number(qty.value) || 1) - 1)); render(); });
      on(q('[data-plus]'), 'click', () => { qty.value = String(Math.max(1, (Number(qty.value) || 1) + 1)); render(); });
      on(q('[data-thumbnails]'), 'click', e => { const b = e.target.closest('[data-photo]'); if (b) showPhoto(b.dataset.photo, b.dataset.alt, qa('[data-photo]').indexOf(b)); });
      const addToBag = async e => {
        e.preventDefault();e.stopPropagation();if (busy) return;
        if (!variant?.available) { notify('Choose an available size to find your soft landing.'); qa('.sizes input').find(i => !i.disabled)?.focus();return; }
        if (!Number.isInteger(Number(qty.value)) || Number(qty.value) < 1) {notify('Choose a quantity of at least 1.');return;}
        busy = true;notify('');render();
        try {
          const res = await fetch(this.dataset.root + 'cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items:[{id:variant.id,quantity:Number(qty.value)}]}) });
          const result = await res.json();if (!res.ok) throw new Error(result.description || result.message || 'We couldn’t add that pair. Please try again.');
          // UpCart handles the Ajax response and opens the existing store drawer.
          busy = false;render();
        } catch (err) { notify(err.message || 'Something went wrong. Please try again.'); busy = false;render(); }
      };
      on(form, 'submit', addToBag);
      add.type = 'button';
      on(add, 'click', addToBag);
      this.addEventListener('click', e => {
        const link = e.target.closest('a[href^="#Oka"]');
        if (!link) return;
        const target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault(); e.stopPropagation();
        target.scrollIntoView({behavior: 'instant', block: 'start'});
      }, {capture: true, signal: this.controller.signal});
      const dialog = q('[data-dialog]');let opener;
      const openDialog = (type, trigger) => {opener = trigger;q('[data-dialog-size]').hidden = type !== 'size';q('[data-dialog-image]').hidden = type !== 'image';dialog.classList.toggle('photo-dialog', type === 'image');if(type==='image'){const image=q('[data-dialog-image] img');image.src=q('.oka-hero').src;image.alt=q('.oka-hero').alt;}dialog.showModal();};
      on(q('[data-size-guide]'), 'click', e => openDialog('size', e.currentTarget));
      on(q('[data-zoom]'), 'click', e => openDialog('image', e.currentTarget));
      on(q('[data-close]'), 'click', () => dialog.close());
      on(dialog, 'close', () => opener?.focus());
      on(dialog, 'click', e => {if(e.target === dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
      const updateSticky = () => { q('[data-sticky]').hidden = q('.buy-row').getBoundingClientRect().bottom >= 0; };
      window.addEventListener('scroll', updateSticky, {passive: true, signal: this.controller.signal});
      on(window, 'resize', updateSticky);
      updateSticky();
      gallery();render();
    }
    disconnectedCallback() {this.controller?.abort();this.ready = false;}
  });
})();
